export const escapedXmlCharacterMap = new Map<string, string>([
    [ '&amp;', '&' ],
    [ '&apos;', '\'' ],
    [ '&quot;', '"' ],
    [ '&lt;', '<' ],
    [ '&gt;', '>' ],
]);
